<template>
    <div class="wrapper">
        <div class="main-panel">
            <div class="main-content">
                <div class="content-wrapper">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-md-12">
                          <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                          <h2 class="content-header">{{ $t("labels.news")  }}</h2>
                        </div>
                      </div>
                      <div class="row" v-if="articles.length > 0">
                          <list-item v-for="article in articles" :key="article._id" :item="article"></list-item>
                      </div>
                      <div class="row" v-show="totalDocs > 9">
                          <div class="col-md-12">
                              <div class="dataTables_paginate paging_simple_numbers">
                                  <ul class="pagination">
                                      <li class="paginate_button page-item previous" v-if="hasPrevPage">
                                          <a href="#" @click.prevent="toPage(prevPage)" class="page-link">{{ $t("labels.previous") }}</a>
                                      </li>
                                      <li class="paginate_button page-item" :class="{ active: p === page }" v-for="p in totalPages" :key="p">
                                          <a href="#" @click.prevent="toPage(p)" class="page-link">{{ p }}</a>
                                      </li>
                                      <li class="paginate_button page-item next" v-if="hasNextPage">
                                          <a href="#" @click.prevent="toPage(nextPage)" class="page-link">{{ $t("labels.next") }}</a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsService from '@/services/news'
import ListItem from './ListItem'
import moment from 'moment'

export default {
    components: {
        ListItem
    },
    data() {
        return {
            articles: [],
            hasPrevPage: false,
            hasNextPage: false,
            page: 1,
            totalPages: 1,
            totalDocs: 0,
            limit: 0,
            prevPage: null,
            nextPage: null
        }
    },
    methods: {
      back() {
        this.$router.push({ name: 'home'})
      },
      getArticles: async function(p) {
          let result = await NewsService.published(p)
          if (result) {
              this.articles = result.data.docs
              this.hasPrevPage = result.data.hasPrevPage
              this.hasNextPage = result.data.hasNextPage
              this.page = result.data.page
              this.limit = result.data.limit
              this.totalPages = result.data.totalPages
              this.prevPage = result.data.prevPage
              this.nextPage = result.data.nextPage
              this.totalDocs = result.data.totalDocs
          }
      },
      toPage: async function(p) {
          if (p !== this.page) {
              await this.getArticles(p)
          }
      }
    },
    mounted: async function() {
        await this.getArticles(1)
    }
}
</script>


<style lang="scss">
    article {
        a {
            color: #eaa24e;

            &:hover {
                color: darken(#eaa24e,10%)
            }
        }

        img {
            max-width: 100%;
        }

        h3 {
            padding: 15px 0 0 15px;
            margin-bottom: 0;
        }

        p {
            padding: 15px;
        }

        svg {
            width: 36px;
            fill: #ccc;
            transition: all .5s ease;
        }

        .published {
            color: #aaa;
        }
    }

    .articleRating {
        width: 100%;
        margin-bottom: 15px;

        td {
            text-align: center;
            font-weight: bold;
        }
    }

    .positive {
        color: green;
        &:hover {
            fill: green;
        }
    }

    .neutral {
        color: orange;
        &:hover {
            fill: orange;
        }
    }

    .bad {
        color: red;
        &:hover {
            fill: red;
        }
    }
</style>

